import React from "react";
import { Link } from "@tanstack/react-router";
import type { ResourceInsert } from "../../../drizzle/schema";
import { Card, CardContent, CardDescription, CardTitle } from "./card";
import { CDNImage } from "./cdn-image";
import { Button } from "./button";
import { ChevronRight } from "lucide-react";

interface ResourceCardProps {
  resource: ResourceInsert;
  coachUsername: string;
  className?: string;
}

export const ResourceCard = ({
  resource,
  coachUsername,
  className,
}: ResourceCardProps) => {
  return (
    <Link
      to="/$username/resources/$resourceId"
      params={{ username: coachUsername, resourceId: resource.id || "" }}
    >
      <Card className={className}>
        <CardContent className="flex h-full flex-col gap-2">
          {resource.imageSrc ? (
            <CDNImage
              src={resource.imageSrc}
              alt={resource.title}
              width={384}
              height={192}
              className="mb-4 aspect-[1/2] h-48 w-full rounded-lg object-cover"
            />
          ) : (
            <div className="mb-4 aspect-[1/2] w-full rounded-lg bg-gray-200" />
          )}
          <CardTitle>{resource.title}</CardTitle>
          <CardDescription className="grow-1">
            {resource.description}
          </CardDescription>
          <Button variant="secondary" className="mt-2">
            Read more <ChevronRight />
          </Button>
        </CardContent>
      </Card>
    </Link>
  );
};
